import { render, staticRenderFns } from "./SortableTh.vue?vue&type=template&id=344da77e&scoped=true"
import script from "./SortableTh.vue?vue&type=script&lang=js"
export * from "./SortableTh.vue?vue&type=script&lang=js"
import style0 from "./SortableTh.vue?vue&type=style&index=0&id=344da77e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344da77e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344da77e')) {
      api.createRecord('344da77e', component.options)
    } else {
      api.reload('344da77e', component.options)
    }
    module.hot.accept("./SortableTh.vue?vue&type=template&id=344da77e&scoped=true", function () {
      api.rerender('344da77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/SortableTh.vue"
export default component.exports